export const IRD_MENU_NODES_PER_PAGE = Object.freeze({
  hctv: {
    items: 8,
    categories: 8,
  },
  tv: {
    items: 6,
    categories: 5,
  },
  phone: {
    items: Number.MAX_SAFE_INTEGER,
    categories: Number.MAX_SAFE_INTEGER,
  },
});
